import img from '../../../../assets/images/illustrations/img-NBS-bannert.png';

const InstitutionBanner = () => {
  return <img src={img} alt="img" style={{ width: '100%' }} />;
};

export default InstitutionBanner;
